import React from 'react';
import styled, { css } from 'styled-components';
import { Logo } from '../../../components/Navigation/Logo';
import { MobileTrigger } from '../../../components/Navigation/MobileTrigger';
import { SmartContainer } from '../../../styles/Containers';
import { respondTo, Theme } from '../../../styles/Theme';
// import logo from '../../../assets/icon-star.png'
import logo from '../../../assets/icon-black-green.png'
import logoFull from '../../../assets/logo-full.png'
import { ThisAccount } from '../../../redux/Account/account.selectors';
import { Link } from 'react-router-dom';
import { ImageCroppingPresets, MediaImage } from '../../../modules/Media/MediaUtils';

const MobileOnlyContainer = styled(SmartContainer)`
    display: none !important;
    border-bottom: ${Theme.borderWidth} solid ${Theme.colors.dark};
    ${respondTo('mobile', css`
        display: flex !important;
        & + * {
            margin-top: 4.5em;
        }
    `)}

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: ${Theme.colors.baseAlternate};
    padding: 0.5em 1.25em;
    z-index: 999;
    
    
`

export const MobileNavigation = () => {
    const thisAccount = ThisAccount();


    return (
        <MobileOnlyContainer data-mobile-navigation flex align="center" justify="space-between">
            {!thisAccount?.meta?.icon && (<Logo src={logo} />)}
            {thisAccount?.meta?.icon && (
                <SmartContainer>
                    <Link to="/">
                        <MediaImage radius id={thisAccount?.meta?.icon} crop={ImageCroppingPresets.thumbnail} style={{ maxWidth: '50px', marginLeft: 'auto', marginRight: 'auto' }} />
                    </Link>
                </SmartContainer>
            )}
            <MobileTrigger />
        </MobileOnlyContainer>
    )
}